import VariantData from '../selectors/variant-data';

export const track = ({ eventName, data }) => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: eventName,
    ...data
  });
};

export const userId = () => window.__st.cid; // eslint-disable-line no-underscore-dangle

export const parsePageType = (classList) => {
  if (classList.contains('index')) {
    return 'Home';
  }
  if (classList.contains('product')) {
    return 'Product';
  }
  if (classList.contains('collection')) {
    return 'Collection';
  }
  if (classList.contains('reviews')) {
    return 'Product Review';
  }
  if (classList.contains('science')) {
    return 'Product Technical';
  }
  if (classList.contains('article')) {
    return 'Article';
  }
  if (classList.contains('blog')) {
    return 'Blog';
  }
  return 'Default';
};

export const formatDate = ({ date }) => date.toISOString();

export const currentDate = () => formatDate({ date: new Date() });

export const getVariantData = (variantId) => {
  const variantData = new VariantData();
  const data = variantData.getData(variantId);
  const purchaseType = data.subscriptionId ? 'Subscription' : 'One-time Order';

  return {
    purchaseType,
    ...data
  };
};

export const getGlobalSubscriptionState = () => window.currentVariantStorage.getState().subscription;

export const getCustomerData = () => {
  if (userId() && window?.customerDataSelector?.getData(userId())) {
    const {
      firstName,
      lastName,
      id,
      email
    } = window.customerDataSelector.getData(userId());

    return {
      firstName,
      lastName,
      id,
      email,
      logged_in: 'true'
    };
  }

  return null;
};

export const BRAND = 'Ketone-IQ';

export default {
  track,
  userId,
  parsePageType,
  formatDate,
  currentDate,
  BRAND,
  getVariantData,
  getGlobalSubscriptionState,
  getCustomerData
};
